jQuery(function ($) {

    // products safari fix
    $('ul.products').css('display','-webkit-flex');

    // Enable Magnific Popup for gallery
    $('.gallery').each(function() {
        $(this).magnificPopup({
            delegate: 'a',
            type: 'image',
            gallery: {
                enabled: true,
                tCounter: '%curr% / %total%' 
            },
            image: {
                titleSrc: 'title' 
                // this tells the script which attribute has your caption
            }            
        });
    });

    // change navigation icon for logged in users
    $('.logged-in .nav-collapse .menu-item-6766 i').removeClass('fa-key').addClass('fa-user-lock');

    // woocommerce custom product amount buttons
    $('form.cart').on( 'click', 'button.plus, button.minus', function() {
  
      // Get current quantity values
      var qty = $( this ).closest( 'form.cart' ).find( '.qty' );
      var val   = parseFloat(qty.val());
      var max = parseFloat(qty.attr( 'max' ));
      var min = parseFloat(qty.attr( 'min' ));
      var step = parseFloat(qty.attr( 'step' ));

      // Change the value if plus or minus
      if ( $( this ).is( '.plus' ) ) {
         if ( max && ( max <= val ) ) {
            qty.val( max );
         } else {
            qty.val( val + step );
         }
      } else {
         if ( min && ( min >= val ) ) {
            qty.val( min );
         } else if ( val > 1 ) {
            qty.val( val - step );
         }
      }
   });
});
